'use client'

import { useEffect, useState } from 'react'

export default function Loading() {
  const [progress, setProgress] = useState(0)

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 98) {
          clearInterval(timer)
          return 98
        }
        return prev + Math.random() * 15
      })
    }, 200)

    return () => clearInterval(timer)
  }, [])

  return (
    <div className="fixed inset-0 bg-[#F8F6F2] z-50 flex items-center justify-center">
      <div className="text-center">
        <div className="relative mb-8">
          {/* Animated geometric shape */}
          <div className="w-24 h-24 mx-auto">
            <div className="absolute inset-0 bg-[#1A1A1A] rounded-lg animate-pulse"></div>
            <div className="absolute inset-0 bg-[#1A1A1A] rounded-lg animate-pulse animation-delay-200 opacity-50"></div>
            <div className="absolute inset-0 bg-[#1A1A1A] rounded-lg animate-pulse animation-delay-400 opacity-25"></div>
          </div>
        </div>

        <p className="text-xs font-sans uppercase tracking-[1.5px] text-[#8A8A8A] mb-4">
          Loading...
        </p>

        <div className="font-serif text-[clamp(80px,10vw,120px)] text-[#1A1A1A] leading-none">
          {Math.floor(progress)}%
        </div>
      </div>
    </div>
  )
}
